import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

/**
 * QR de invitación a la sala. Codifica la URL de entrada con el código de
 * sesión y el PIN COMPARTIDO prellenados — el PIN es dato público de
 * proyección (se muestra gigante en la Pantalla igual), así que viajarlo en
 * la URL del QR no expone nada que la sala no vea ya. El participante escanea,
 * escribe su nombre y entra (auto-registro, Lote 6).
 *
 * SVG nativo (qrcode-generator, cero dependencias transitivas): hereda el
 * color con `currentColor`, así que el contenedor decide el contraste.
 */
export function QrSala({
  codigoSesion,
  pin,
  tamano = 220,
}: {
  codigoSesion: string;
  /** PIN compartido si existe; sin él, el QR lleva solo el código (la persona
   *  entra con Google o con su PIN personal impreso). */
  pin?: string | null;
  /** Lado en px del SVG (el QR escala vectorial). */
  tamano?: number;
}) {
  const url = `${window.location.origin}/login?sala=${encodeURIComponent(codigoSesion)}${
    pin ? `&pin=${encodeURIComponent(pin)}` : ''
  }`;

  const { celdas, modulos } = useMemo(() => {
    const qr = qrcode(0, 'M'); // versión automática, corrección M
    qr.addData(url);
    qr.make();
    const n = qr.getModuleCount();
    const puntos: [number, number][] = [];
    for (let f = 0; f < n; f += 1) {
      for (let c = 0; c < n; c += 1) {
        if (qr.isDark(f, c)) puntos.push([c, f]);
      }
    }
    return { celdas: puntos, modulos: n };
  }, [url]);

  return (
    <svg
      width={tamano}
      height={tamano}
      viewBox={`0 0 ${modulos} ${modulos}`}
      role="img"
      aria-label={`Código QR para entrar a la sala ${codigoSesion}`}
      shapeRendering="crispEdges"
    >
      {/* Fondo claro fijo: un QR necesita contraste real también en tema navy. */}
      <rect width={modulos} height={modulos} fill="white" />
      {celdas.map(([x, y]) => (
        <rect key={`${x}-${y}`} x={x} y={y} width={1} height={1} fill="black" />
      ))}
    </svg>
  );
}
